
  import { defineComponent, PropType } from 'vue'

  import { IWorkout } from '@/types/workouts'
  import { getApiUrl } from '@/utils'

  export default defineComponent({
    name: 'StaticMap',
    props: {
      workout: {
        type: Object as PropType<IWorkout>,
        required: true,
      },
      displayHover: {
        type: Boolean,
        default: false,
      },
    },
    setup() {
      return { getApiUrl }
    },
  })
